import { Signal, useComputed } from "@suse-o11y/signal";

/**
 * This signal holds whether drag-and-drop is enabled in the application.
 * It is initially false to avoid loading the heavy `beautiful-dnd` library
 * until the user actually tries to drag something.
 * As soon as the user hovers over a `DragHandle`, we set this to true,
 * which will cause all `DragAndDrop` components to load the library.
 */
const isDragAndDropEnabled = Signal(false);

export function useIsEnabled(): boolean {
	return useComputed((monitor) => isDragAndDropEnabled.read(monitor));
}

export function enable(): void {
	isDragAndDropEnabled.write(true);
}
